if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"runtime~main": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"src_pages_CommandCenterPage_CommandCenter_page_js":1,"src_pages_AutoAssignPage_AutoAssign_page_jsx":1,"src_oldComponents_ImportUsers_index_js":1,"src_oldComponents_Analitics_AnaliticsComponent_js":1,"src_oldComponents_Teams_EditDetailTeam_js":1,"src_client_utils_forms_Questions_BarCodeForm_js-src_client_utils_forms_Questions_BinaryRating-e0dae8":1,"src_oldComponents_AssetInventory_AssetInventoryManager_js":1,"src_components_FielderElements_SmartFunctionalityTable_SmartFunctionalityTable_jsx-src_oldCom-6edf98":1,"src_oldComponents_AssetsManagement_AssetsManagement_css-src_oldComponents_AssetsManagement_Ca-22e3a9":1,"src_oldComponents_ApiPreferences_UserApiPreferences_js":1,"src_oldComponents_Billing_Billing_js":1,"src_oldComponents_DynamicAllocation_index_js":1,"src_oldComponents_Expenses_index_js":1,"src_oldComponents_Forms_index_js":1,"src_oldComponents_GlobalAccountComponents_DashboardClientGlobalAccount_index_js":1,"src_oldComponents_GlobalAccountComponents_DashboardGlobalAccount_index_js":1,"src_oldComponents_GlobalSearch_Pagination_js":1,"src_oldComponents_GlobalSearch_GlobalSearchComponent_js":1,"src_oldComponents_InternalAdminComponents_Accounts_index_js":1,"src_oldComponents_InternalAdminComponents_GlobalUser_index_js":1,"src_oldComponents_InternalAdminComponents_ReviewAccount_index_js":1,"src_oldComponents_Inventory_index_js":1,"src_oldComponents_Invoice_InvoiceComponent_js":1,"src_oldComponents_Partners_Partners_js":1,"src_oldComponents_RoleManagement_RoleManagement-container_js":1,"src_oldComponents_Routes_index_js":1,"src_oldComponents_Sms_index_js":1,"src_oldComponents_TaskTypes_index_js":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr